import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./Taluka.css";
import { baseUrl } from "../../../utils/httpService";
import Top5FeaturedNews from "./Top5FeaturedNews";
import NewsCard from "./NewsCard";
import GoogleNewsSidebar from "./GoogleNewsSidebar";
import { AllViewCountActionFetchData } from "../../../redux/actions/AllViewCountAction";

const TalukaDetailspage = ({ talukaData, parentCity }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const { assetbaseUrl } = useSelector(
    (state) => state?.SettingReducer?.data || {}
  );

  // Fetch search API results for selected taluka
  useEffect(() => {
    if (!talukaData) return;
    if (page === 1) {
      setSearchLoading(true);
    } else {
      setLoadingMore(true);
    }
    const keyword = talukaData.gujarati_name || talukaData.name || "";
    fetch(`${baseUrl}search?keyword=${encodeURIComponent(keyword)}&limit=12&page=${page}`)
      .then((res) => res.json())
      .then((json) => {
        if (json.status && json.data) {
          const list = Array.isArray(json.data)
            ? json.data
            : (json.data.data || json.data.result || []);

          if (page === 1) {
            setSearchResults(list);
          } else {
            setSearchResults(prev => [...prev, ...list]);
          }
          if (list.length < 12) {
            setHasMore(false);
          }
        } else {
          if (page === 1) setSearchResults([]);
          setHasMore(false);
        }
        setSearchLoading(false);
        setLoadingMore(false);
      })
      .catch((err) => {
        console.error("Error fetching taluka search API:", err);
        if (page === 1) setSearchResults([]);
        setSearchLoading(false);
        setLoadingMore(false);
        setHasMore(false);
      });
  }, [talukaData, page]);

  // Reset page when talukaData changes
  useEffect(() => {
    setPage(1);
    setSearchResults([]);
    setHasMore(true);

    if (talukaData) {
      document.title = "Taluka Page";
      dispatch(AllViewCountActionFetchData(window.location.pathname));
    }
  }, [talukaData?.id]);

  if (!talukaData) return null;

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }
    const baseImgUrl = assetbaseUrl?.value || "https://epapercdn.sandesh.com/";
    const cleanPath = path.startsWith("/") ? path.slice(1) : path;
    return `${baseImgUrl}${cleanPath}`;
  };

  const apiNews = talukaData?.news || talukaData?.articles || talukaData?.related_news || talukaData?.news_list || [];
  const displayItems = (searchResults && searchResults.length > 0)
    ? searchResults
    : apiNews;

  return (
    <div className="taluka-container container">
      <div className="row">
        {/* Left Column: Breadcrumb, Title, Description Card, AND News Feed */}
        <div className="col-lg-9 col-md-12">
          {/* Ultra Modern Header Banner */}
          <div className="taluka-hero-banner">
            <div className="hero-bg-shapes">
              <div className="hero-circle hero-circle-1"></div>
              <div className="hero-circle hero-circle-2"></div>
              <div className="hero-circle hero-circle-3"></div>
            </div>

            <div className="hero-top-row" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <div className="detail-breadcrumb" style={{ zIndex: 2, marginBottom: '15px', background: 'rgba(255, 255, 255, 0.7)', padding: '6px 12px', borderRadius: '8px', backdropFilter: 'blur(4px)', border: '1px solid rgba(174, 10, 11, 0.1)' }}>
                <span
                  className="breadcrumb-link"
                  onClick={() => navigate(`/${parentCity?.url || 'gujarat-taluka-news'}`)}
                  style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', color: '#ae0a0b', fontWeight: '700', fontSize: '13px' }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                    <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
                    <line x1="8" y1="2" x2="8" y2="18"></line>
                    <line x1="16" y1="6" x2="16" y2="22"></line>
                  </svg>
                  {parentCity?.gujarati_name || parentCity?.name || 'જિલ્લો'}
                </span>
                <span style={{ margin: '0 8px', color: '#94a3b8' }}>›</span>
                <span className="breadcrumb-current" style={{ color: '#475569', fontWeight: '600', fontSize: '13px' }}>{talukaData.gujarati_name || talukaData.name}</span>
              </div>

              <div className="hero-title-group" style={{ zIndex: 2 }}>
                <div className="hero-icon-wrap">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div>
                  <h1 className="hero-main-title">
                    <span className="title-highlight">{talukaData.gujarati_name || talukaData.name}</span>{" "}
                    <span className="title-main">તાલુકા સમાચાર</span>{" "}
                    <span className="title-sub" style={{ fontSize: '14px', color: '#64748b', fontWeight: '600', marginLeft: '6px' }}>
                      ({talukaData.name} )
                    </span>
                  </h1>
                </div>
              </div>
            </div>

            <div className="hero-city-filter-wrapper" style={{ zIndex: 2, borderTop: '1px solid rgba(174, 10, 11, 0.1)', paddingTop: '16px', marginTop: '16px', display: 'block' }}>
              <div className="detail-desc-text" style={{ fontSize: '15px', lineHeight: '1.8', color: '#475569', margin: 0 }} dangerouslySetInnerHTML={{ __html: talukaData.description || 'આ તાલુકા વિશે વધુ માહિતી ટૂંક સમયમાં ઉપલબ્ધ થશે.' }}></div>
            </div>
          </div>

          <div className="taluka-detail-content mt-4">
            {/* News Feed Section */}
            <div className="city-news-section">
              <h2 className="section-title">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ae0a0b" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', flexShrink: 0 }}>
                  <path d="M19 20H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1m2 13a2 2 0 0 1-2-2V7m2 13a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2"></path>
                  <line x1="7" y1="8" x2="11" y2="8"></line>
                  <line x1="7" y1="12" x2="13" y2="12"></line>
                  <line x1="7" y1="16" x2="13" y2="16"></line>
                </svg>
                <span style={{ flex: 1 }}>
                  આજના <span className="title-highlight">{talukaData.gujarati_name || talukaData.name}</span> તાલુકાના સમાચાર
                </span>
              </h2>

              <Top5FeaturedNews items={displayItems.slice(0, 6)} talukaName={talukaData.gujarati_name || talukaData.name} />

              {/* Simple 3-column Grid Layout requested by user */}
              {searchLoading && page === 1 ? (
                <div className="row">
                  <div className="col-12 text-center py-4 text-muted">
                    સમાચાર લોડ થઈ રહ્યા છે...
                  </div>
                </div>
              ) : displayItems && displayItems.length === 0 ? (
                <div className="row mt-3 mb-5">
                  <div className="col-12">
                    <div className="py-5 bg-white text-center" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 2px 10px rgba(0,0,0,0.02)" }}>
                      <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "72px", height: "72px", borderRadius: "50%", background: "#f8fafc", marginBottom: "16px" }}>
                        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v4"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                          <line x1="8" y1="13" x2="16" y2="13"></line>
                          <line x1="8" y1="17" x2="16" y2="17"></line>
                        </svg>
                      </div>
                      <h4 style={{ color: "#334155", fontWeight: "600", fontSize: "20px", marginBottom: "8px" }}>કોઈ સમાચાર ઉપલબ્ધ નથી</h4>
                      <p style={{ color: "#64748b", fontSize: "16px", margin: 0 }}>
                        <span className="title-highlight">{talukaData.gujarati_name || talukaData.name}</span> તાલુકાના નવા સમાચાર ટૂંક સમયમાં અપડેટ કરવામાં આવશે.
                      </p>
                    </div>
                  </div>
                </div>
              ) : displayItems && displayItems.length > 6 ? (
                <>
                  <div className="row substory">
                    {displayItems.slice(6).map((item, index) => (
                      <div className="col-lg-4 col-md-6 mb-4" key={item.id || index}>
                        <NewsCard
                          item={item}
                          assetbaseUrl={assetbaseUrl}
                          fallbackCategoryName={talukaData.gujarati_name || talukaData.name}
                        />
                      </div>
                    ))}
                  </div>

                  {hasMore && (
                    <div className="row mt-4 mb-5">
                      <div className="col-12 text-center">
                        <button
                          className="btn btn-dark"
                          style={{ borderRadius: "20px", padding: "8px 24px", fontWeight: "600", fontSize: "14px", backgroundColor: "#1e293b" }}
                          onClick={() => setPage(prev => prev + 1)}
                          disabled={loadingMore}
                        >
                          {loadingMore ? "લોડ થઈ રહ્યું છે..." : "વધુ સમાચાર જુઓ"} <i className="fa fa-angle-down ml-1"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>

        {/* Right Column: Google News Follow Card + Ad Section */}
        <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
          <GoogleNewsSidebar />
        </div>
      </div>
    </div>
  );
};

export default TalukaDetailspage;
